/**
 * Clave de consulta de las regularizaciones (007 · T032; contracts/ui.md §1.1, research R-16).
 *
 * Vive en su propio módulo (sin dependencias) para que `features/history/api.ts`
 * (`invalidateAttendanceViews`) la importe sin crear un ciclo con `./api.ts`, que a su vez usa
 * `invalidateAttendanceViews` tras enviar o cancelar. `./api.ts` la reexporta: el nombre público
 * es `STAFF_REGULARIZATIONS_QUERY_KEY` de `features/regularization/api.ts` (wiring 007 §6.2).
 */
export const STAFF_REGULARIZATIONS_QUERY_KEY = ['staff-regularizations'] as const;
